import { render, staticRenderFns } from "./_id.tabLayout.vue?vue&type=template&id=090e680a&scoped=true&"
import script from "./_id.tabLayout.vue?vue&type=script&lang=js&"
export * from "./_id.tabLayout.vue?vue&type=script&lang=js&"
import style0 from "./_id.tabLayout.vue?vue&type=style&index=0&id=090e680a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090e680a",
  null
  
)

export default component.exports